<template>
  <div>
    <!-- header start -->
    <div class="bg-light">
      <div class="col-lg-10 offset-lg-1">
        <div class="row">
          <div class="col-sm-12">

            <h4 class="mt-5 header_decoration position-relative pb-2 d-inline-block">{{ __('search_results') }}
              '<strong>{{ results.query }}</strong>'</h4>
            <h6 v-if="window.AG.canSeeBack" class="h7 mb-5">{{ __('search-not-restricted') }}.</h6>
            <h6 v-else class="h7 mb-5">{{
                __('search-restricted')
              }}{{ new Date().getFullYear() - 2 }}
              -{{ new Date().getFullYear() }}.</h6>
          </div>
        </div>
      </div>
    </div>
    <!-- header end -->
    <div v-if="results.hits > 0" class="col-lg-10 offset-lg-1 mt-3 mb-1 mb-md-5">
      <div class="d-flex justify-content-start" v-if="window.innerWidth < 960">
        <a
            id="filtersToggle"
            class="text-uppercase h7 py-2 ml-3"
            @click="filtersHidden = !filtersHidden"
        ><u>{{ __('show_hide_filters') }}</u></a>
      </div>
      <div
          v-if="!filtersHidden"
          :class="{filtersHidden : 'd-none'}"
          id="filtersToolbar"
          class="d-md-block toolbar justify-content-between offset-lg-1 col-lg-10 my-4"
      >
        <div class="row">
          <div class="col-lg-3 mb-sm-3">
            <h6 class="h7 text-uppercase text-muted"> {{ __('filter_lots_by') }} </h6>
            <select v-model="filter_by"
                    class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0"
                    name="search-filter-lots">
              <option :value="v" v-for="v in search_filter_by_options">{{ __(v) }}</option>
            </select>
          </div>
          <div class="col-lg-3 mb-sm-3">
            <h6 class="h7 text-uppercase text-muted"> {{ __('order_lots_by') }} </h6>
            <select v-model="order_by"
                    class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0"
                    name="search-order-lots">
              <option :value="v" v-for="v in search_order_by_options">{{ __(v) }}</option>
            </select>
          </div>
          <div class="col-lg-3 mb-sm-3">
            <h6 class="h7 text-uppercase text-muted"> {{ __('lots_per_page') }} </h6>
            <select v-model="show_per_page"
                    class="form-control search myAccount-form-control-custom box_select_no_borders input__placeholder px-0"
                    name="search-lots-per-page">
              <option v-if="v <= results.hits" :value="v" v-for="v in per_page_options">{{ v }}</option>
              <option v-if="results.hits <= Math.max.apply(Math, this.per_page_options)" :value="results.hits">
                {{ __('all') }} ({{
                  results.hits
                }})
              </option>
            </select>
          </div>
          <div class="col-lg-3 d-flex flex-column">
            <h6 class="h7 text-uppercase text-muted"> {{ __('lots_on_page') }} </h6>
            <p>{{ results.hits }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid center-vertically">
      <div class="loader mb-5" style="margin-left: 50%" v-if="loading">
        <svg
            version="1.1"
            id="da-loader"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="40px"
            height="40px"
            viewBox="0 0 50 50"
            style="enable-background:new 0 0 50 50;"
            xml:space="preserve"
        >
          <path
              fill="#000"
              d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
          >
            <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="0.6s"
                repeatCount="indefinite"
            />
          </path>
        </svg>
      </div>

      <!-- no results start -->
      <div v-if="results.hits == 0 && !loading" class="container">
        <div class="row">
          <div class="col-sm-12 mt-4 mb-4" style="text-align: center;">
            <p> {{ __('no-results') }}</p>
            <a :href="results.noHitsLink"
               style="padding-left: 0px;color:blue;text-decoration: underline">{{ __('auctions-current') }}</a>
          </div>
        </div>
      </div>
      <!-- no results end -->

      <!-- lot findings start -->
      <div v-if="results.hits > 0" class="row" id="searchResults" style="width: 100%">
        <lot
            v-if="lot.status === 1"
            :auction="lot.auction"
            :lot="lot"
            :key="lot.id"
            v-for="lot in lotsToShow"
        />
      </div>
    </div>
    <div v-if="results.hits > 0 && !loading" class="container">
      <div class="row pagination">
        <div class="col-1"></div>
        <div class="col text-center my-3">
          <nav aria-label="labels" style="background: white !important;">
            <ul class="pagination justify-content-center mb-5">
              <li class="page-item prev" :class="hasPrevious">
                <button @click="changePage('prev')" class="page-link" :aria-label="__('prevpage')">
                  <svg
                      width="40"
                      height="40"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <polyline fill="none" stroke="#000" stroke-width=".5"
                              points="13 16 7 10 13 4"/>
                  </svg>
                </button>
              </li>
              <li class="page-item" :class="isCurrentPage(p)" v-for="p in proximityPages">
                <button @click="changePage(p)" class="page-link" :aria-label="__('page')"
                >{{ p }}
                </button>
              </li>
              <li class="page-item next" :class="hasNext">
                <button @click="changePage('next')" class="page-link" :aria-label="__('nextpage')">
                  <svg
                      width="40"
                      height="40"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <polyline fill="none" stroke="#000" stroke-width=".5"

                              points="7 4 13 10 7 16"/>
                  </svg>
                </button>
              </li>
            </ul>
          </nav>
        </div>
        <div class="col-1"></div>
      </div>
    </div>

  </div>
</template>
<script>

import {APP} from "../constants.js";
import {mapGetters} from "vuex";
import * as types from "../store/mutations";
import store from "../store";

export default {
  data: function () {
    return {
      filtersHidden: false,
      loading: false,
      lotIds: {},
      lotsToShow: {},
      page: 1,
      perPage: 9,
      ordering: 'LOT_DATE',
      filtering: 'all'
    }
  },
  props: ["results"],
  computed: {
    console: () => console,
    window: () => window,
    per_page_options: function () {
      return APP.LOTS_PER_PAGE.VALUES;
    },
    search_order_by_options: function () {
      return ['LOT_DATE', 'LOT_PRICE_ASC', 'LOT_PRICE_DESC'];
    },
    search_filter_by_options: function () {
      return ['LOT_SOLD', 'LOT_UNSOLD', 'all'];
    },
    pages: function () {
      var start = 1;
      var end = Math.ceil(this.results.hits / this.show_per_page);
      return Array(end - start + 1)
          .fill()
          .map((item, index) => start + index);
    },
    hasPrevious: function () {
      return this.currentPage == 1 ? "disabled" : "";
    },
    hasNext: function () {
      return this.currentPage == this.results.hits / this.show_per_page ? "disabled" : "";
    },
    nextPage: function () {
      return parseInt(this.currentPage) + 1;
    },
    prevPage: function () {
      return parseInt(this.currentPage) - 1;
    },
    currentPage: function () {
      return this.page || 1;
    },
    show_per_page: {
      get: function () {
        return this.perPage;
      },
      set: function (show) {
        this.reChunkLotIds(this.lotIds, show, true);
        this.perPage = show;
        this.setUrlParams('per_page', show)
        this.changePage(1);
      }
    },
    filter_by: {
      get: function () {
        return this.filtering;
      },
      set: function (filter) {
        this.filtering = filter;
        this.filterLots(filter);
      }
    },
    order_by: {
      get: function () {
        return this.ordering;
      },
      set: function (order) {
        this.ordering = order;
        this.orderLots(order);
      }
    },
    proximityPages() {
      if (!this.currentPage) {
        return "";
      }
      var curr = parseInt(this.currentPage);
      var total = Math.ceil(this.countFilteredLots() / this.show_per_page);
      var pages = [
        curr - 3,
        curr - 2,
        curr - 1,
        curr,
        curr + 1,
        curr + 2,
        curr + 3
      ].filter(function (value) {
        if (value <= 0) {
          return false;
        } else if (value > total) {
          return false;
        }
        return true;
      });
      return pages;
    },
  },
  methods: {
    countFilteredLots() {
      let counter;
      if (this.lotIds.length) {
        counter = [].concat.apply([], this.lotIds).length;
      } else {
        counter = this.results.hits;
      }
      return counter;
    },
    filterLots(filter) {
      let flat = [].concat.apply([], this.results.lotIds);
      switch (filter) {
        case 'LOT_SOLD':
          flat = flat.filter(item => (item[Object.keys(item)[0]]['auction_status'] == 1));
          break;
        case 'LOT_UNSOLD':
          flat = flat.filter(item => (item[Object.keys(item)[0]]['auction_status'] == 2));
          break;
        default:
          flat = [].concat.apply([], this.results.lotIds);
      }
      this.reChunkLotIds(flat, this.perPage, false);
      this.setUrlParams('filter_by', filter);
      this.orderLots(this.ordering, filter);
    },
    orderLots(order) {
      let flat = [].concat.apply([], this.lotIds);
      switch (order) {
        case 'LOT_PRICE_ASC':
          flat.sort((a, b) => a[Object.keys(a)[0]]['sorting_price'] - b[Object.keys(b)[0]]['sorting_price'])
          break;
        case 'LOT_PRICE_DESC':
          flat.sort((a, b) => b[Object.keys(b)[0]]['sorting_price'] - a[Object.keys(a)[0]]['sorting_price'])
          break;
        case 'LOT_DATE':
        default:
          flat.sort((a, b) => a[Object.keys(a)[0]]['default_order'] - b[Object.keys(b)[0]]['default_order'])
      }
      this.reChunkLotIds(flat, this.perPage);
      this.setUrlParams('order_by', order)
      this.changePage(1);
    },
    unSetUrlParams(param) {
      let objectURL = new URL(location.href);
      objectURL.searchParams.delete(param);
      window.history.replaceState({path: objectURL.toString()}, '', objectURL.toString());
    },
    setUrlParams(param, value) {
      let objectURL = new URL(location.href);
      objectURL.searchParams.set(param, value);
      if ((objectURL.searchParams.has('page') && objectURL.searchParams.get('page') == 1)
          || (objectURL.searchParams.has('filter_by') && objectURL.searchParams.get('filter_by') == 'all')
          || (objectURL.searchParams.has('per_page') && objectURL.searchParams.get('per_page') == Math.min.apply(Math, this.per_page_options))
      ) {
        objectURL.searchParams.delete(param);
      }

      window.history.replaceState({path: objectURL.toString()}, '', objectURL.toString());
    },
    flattenArray(arr) {
      //get flat!
      return [].concat.apply([], arr);

    },
    reChunkLotIds(lotIds, newChunkSize, flatten = true) {
      let arr = lotIds;
      if (flatten) {
        arr = this.flattenArray(lotIds)
      }
      //re-chunk
      let results = [];

      while (arr.length) {
        results.push(arr.splice(0, newChunkSize))
      }

      this.lotIds = results;
    },
    changePage: function (p) {
      if (p == 'next') {
        p = this.currentPage + 1;
      } else if (p == 'prev') {
        p = this.currentPage - 1;
      }
      this.getLotsToShow(parseInt(p) - 1)
      this.page = p;
      this.setUrlParams('page', p)

    },
    getLotsToShow: function (p) {
      axios.post(`/api/get-lots-by-id`, {
        "lotIds": this.lotIds[p].flatMap(Object.keys),
        "locale": this.results.locale
      })
          .then(response => {
            this.lotsToShow = response.data;
            this.loading = false;
            this.scrollToTop()
          })
          .catch(err => {
            console.log(err)
          })
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    locale: function () {
      return this.results.locale;
    },
    toggleMore: function () {
      this.more = !this.more;
    },
    open_link: function (url) {
      window.open(url, "_blank");
    },
    trim: function (value) {
      value = value.replace(/(^\s*)|(\s*$)/gi, "");
      value = value.replace(/[ ]{2,}/gi, " ");
      value = value.replace(/\n /, "\n");
      try {
        value = value.trimStart();
        value = value.trimEnd();
      } catch (err) {
        //supress errors for trim
      }

      return value;
    },
    __: function (key) {
      return window.AG.trans[key];
    },
    __LIVE: function (key) {
      return window.AG.generic[key];
    },
    route: function (key) {
      return window.AG.routes[key];
    },
    goToLot: function (ev) {
      switch (ev.keyCode) {
        case 13: // henter
          if (this.lotJump) {
            var lot = this.lots.find(lot => lot.number == this.lotJump);
            if (lot != undefined) {
              this.$router.push({
                name: "lot",
                params: {
                  auction: this.auction.slug,
                  lot: lot.slug
                }
              });
            }
          }
          break;
        case 27: // hescape
          this.lotJump = "";
          break;
      }
    },
    goToLotMobile: function () {
      if (this.lotJump) {
        var lot = this.lots.find(lot => lot.number == this.lotJump);
        if (lot != undefined) {
          this.$router.push({
            name: "lot",
            params: {
              auction: this.auction.slug,
              lot: lot.slug
            }
          });
        }
      }
    },
    isCurrentPage: function (page) {
      return this.currentPage == page ? "active" : "";
    },

    openShareModal: function (event) {
      var targetUrl = this.url;
      $('#shareModal').on('show.bs.modal', function (e) {
        $('#facebookShare').attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + window.location.href + "&amp;display=popup")
      });
      event.preventDefault();
    },
    onResize() {
      this.filtersHidden = window.innerWidth < 960;
    },
  },
  created() {
  },
  beforeCreate() {
  },
  beforeDestroy() {
    if (typeof window === 'undefined') return

    window.removeEventListener('resize', this.onResize, {passive: true})
  },
  mounted() {
    if (window.innerWidth < 960) {
      this.filtersHidden = true;
    }
    if (this.results.hits >= 1) {
      let firstPageToShow = 0;
      this.loading = true;
      this.lotIds = this.results.lotIds;
      let objectURL = new URL(location.href);
      if (window.AG.canSeeBack) {
        this.setUrlParams('canSeeBack', 'true');
      } else {
        this.setUrlParams('canSeeBack', 'false');
      }
      //this.perPage = objectURL.searchParams.has('per_page') ? objectURL.searchParams.get('per_page') : this.results.perPage;
      if (objectURL.searchParams.has('filter_by') && window.AG.canSeeBack) {
        //filter before ordering
        this.filtering = objectURL.searchParams.get('filter_by');
      } else {
        this.unSetUrlParams('filter_by')
      }
      if (objectURL.searchParams.has('order_by') && window.AG.canSeeBack) {
        //filter before ordering
        this.ordering = objectURL.searchParams.get('order_by');
      } else {
        this.unSetUrlParams('order_by')
      }
      if (objectURL.searchParams.has('per_page') && window.AG.canSeeBack) {
        this.show_per_page = objectURL.searchParams.get('per_page');
      } else {
        this.show_per_page = this.results.perPage;
        this.unSetUrlParams('per_page')
      }
      if (objectURL.searchParams.has('page') && window.AG.canSeeBack) {
        this.page = objectURL.searchParams.get('page');
        this.setUrlParams('page', objectURL.searchParams.get('page'));
        firstPageToShow = parseInt(objectURL.searchParams.get('page')) - 1;
      } else {
        this.page = this.results.pageNo;
        this.unSetUrlParams('page');
      }
      this.getLotsToShow(firstPageToShow);
    }
  },
  updated() {

  }
};
</script>
